import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

const edit = {
	SmVariaId: null as number | null,
	SmVariaZkt: null as string | null,
	Text: null as string | null,
	TextTisk2Dd: null as string | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {},
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
